import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  useRef,
} from 'react'
import * as authHelper from 'utils/auth-helper'
import Api from 'utils/api'
import Loader from 'components/loader'

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => {},
  currentUser: {
    onBoardingStep: 1,
    account: {
      organisationName: '',
    },
    selectedPlan: null,
    theme: {},
    setTheme: () => {},
    setSelectedPlan: () => {},
    setOnBoardingStep: () => {},
    logout: () => {},
    saveAuth: () => {},
    auth: authHelper.getAuth(),
    setCurrentUser: () => {},
    currentUser: {
      onBoardingStep: 1,
      account: {
        organisationName: '',
      },
    },
  },
  // currentUser: undefined,
  setCurrentUser: () => {},
  onBoardingStep: 1,
  setOnBoardingStep: () => {},
  logout: () => {},
  theme: {},
  setTheme: () => {},
  selectedPlan: null,
  setSelectedPlan: () => {},
}

const defaultTheme = {
  buttonBackgroundColor: '#FF5E36',
  // Was the same value as primary after the palette sweep, which made a themed
  // secondary button indistinguishable from a primary one.
  secondarybuttonBackgroundColor: '#F2ECE7',
  buttonTextColor: 'white',
  pageTextColor: 'black',
  pageBackgroundColor: 'white',
}

const AuthContext = createContext(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(authHelper.getAuth())
  const [currentUser, setCurrentUser] = useState()
  const [onBoardingStep, setOnBoardingStep] = useState(1)
  const [theme, setTheme] = useState(defaultTheme)
  const [selectedPlan, setSelectedPlan] = useState(null)

  const favicon = currentUser?.account?.branding?.faviconImage

  const updateFavicon = (faviconURL) => {
    const link = document.querySelector("link[rel~='icon']")
    if (!link) {
      const newLink = document.createElement('link')
      newLink.rel = 'icon'
      newLink.href = faviconURL
      document.getElementsByTagName('head')[0].appendChild(newLink)
    } else {
      link.href = faviconURL
    }
  }

  useEffect(() => {
    if (currentUser) {
      updateFavicon(favicon)
    }
  }, [favicon, currentUser])

  // Expose currentUser globally for non-react utilities (used by currencyFormat)
  useEffect(() => {
    try {
      // attach to window so utilities can read organisation settings
      if (typeof window !== 'undefined') {
        window.__CURRENT_USER__ = currentUser
      }
    } catch (err) {
      // ignore
    }
    return () => {
      try {
        if (typeof window !== 'undefined' && window.__CURRENT_USER__ === currentUser) {
          window.__CURRENT_USER__ = undefined
        }
      } catch (err) {}
    }
  }, [currentUser])

  const saveAuth = (auth) => {
    setAuth(auth)
    if (auth) {
      authHelper.setAuth(auth)
    } else {
      authHelper.removeAuth()
    }
  }

  const logout = () => {
    saveAuth(undefined)
    setCurrentUser(undefined)
  }

  useEffect(() => {
    console.log('currentUser?.onBoardingStep', currentUser?.onBoardingStep)
    if (currentUser?.onBoardingStep && currentUser?.onBoardingStep > -1)
      setOnBoardingStep(currentUser.onBoardingStep)
    else setOnBoardingStep(1)
  }, [currentUser?.onBoardingStep])

  useEffect(() => {
    if (currentUser?.account?.branding) setTheme(currentUser?.account?.branding)
  }, [currentUser?.account?.branding])

  // Load selectedPlan from user data when user is authenticated
  useEffect(() => {
    if (currentUser?.selectedPlan && !selectedPlan) {
      setSelectedPlan(currentUser.selectedPlan)
    }
  }, [currentUser?.selectedPlan])

  console.log('selectedPlan', selectedPlan)
  console.log('Current User', currentUser)
  console.log('onBoardingStep', onBoardingStep)

  return (
    <AuthContext.Provider
      value={{
        auth,
        saveAuth,
        currentUser,
        setCurrentUser,
        onBoardingStep,
        setOnBoardingStep,
        logout,
        selectedPlan,
        setSelectedPlan,
      }}
    >
      <div
        style={{
          backgroundColor: currentUser?.account?.branding?.pageBackgroundColor,
          color: currentUser?.account?.branding?.pageTextColor,
        }}
      >
        {children}
      </div>
    </AuthContext.Provider>
  )
}

const AuthInit = ({ children }) => {
  const { auth, logout, setCurrentUser } = useAuth()
  const didRequest = useRef(false)
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  useEffect(() => {
    const requestUser = async () => {
      try {
        if (didRequest.current != auth) {
          setShowSplashScreen(true)
          const { response } = await Api('/auth/verify_token', 'get')
          if (response) {
            setCurrentUser(response.data)
          }
        }
      } catch (error) {
        console.error(error)
        if (!didRequest.current) {
          logout()
        }
      } finally {
        setShowSplashScreen(false)
      }

      didRequest.current = auth
    }

    if (auth && auth.token) {
      requestUser(auth.token)
    } else {
      logout()
      setShowSplashScreen(false)
    }
  }, [auth])

  console.log('auth loader', showSplashScreen)

  return showSplashScreen ? (
    <div className='tw-w-full tw-h-[100vh] tw-flex tw-flex-col tw-items-center tw-justify-center'>
      <Loader size={8} />
    </div>
  ) : (
    <>{children}</>
  )
}

export { AuthProvider, AuthInit, useAuth }
